import {connect} from 'react-redux'
import HeaderActions from '../components/header_actions'
import {
  showToast, markRotateHintUsed, TOAST_LINK_COPIED, TOAST_LINK_COPY_FAILED, TOAST_ROTATE_HINT,
} from '../actions/toast_index'
import {setOrientationLocked} from '../actions/leaderboardV2_index'

const mapStateToProps = (state) => ({
  leagueName: state.leaderboardV2.leagueName,
  // Store-held so the orientation button survives its own remounts (it lives
  // inside the keyed selected-event tile) without forgetting the page is
  // still rotated.
  isOrientationLocked: state.leaderboardV2.orientationLocked,
})

const mapDispatchToProps = (dispatch) => ({
  showLinkCopied: () => dispatch(showToast(TOAST_LINK_COPIED)),
  showLinkCopyFailed: () => dispatch(showToast(TOAST_LINK_COPY_FAILED)),
  // Tapping the button already proves the user knows the feature, so this
  // reply to a failed lock is shown without spending the coach-mark budget.
  showRotateHint: () => dispatch(showToast(TOAST_ROTATE_HINT)),
  markRotateHintUsed: () => dispatch(markRotateHintUsed()),
  setOrientationLocked: (locked) => dispatch(setOrientationLocked(locked)),
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderActions)
